<template>
  <v-container fluid>
    <v-col>
      <v-subheader>{{ title }}</v-subheader>
      <v-btn color="success" @click="download">Download</v-btn>
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        :pagination.sync="pagination"
        :loading="loading"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td
            :class="`text-xs-${name.align}`"
            v-for="(name, index) in headers.filter(x => x.text !== 'Actions')"
            :key="index"
          >
            <div v-if="name.value == `x`">
              {{ props.item[name.value] | formatDate }}
            </div>
            <div v-else>{{ props.item[name.value] }}</div>
          </td>
        </template>
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapReportsActions } = createNamespacedHelpers("reports");
export default {
  name: "ListActivity",
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        descending: false
      }
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    headers: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapReportsActions(["getReport"]),
    download() {
      let vm = this;
      vm.isDataLoading = true;
      vm.getReport({
        data: { data: vm.items },
        template: {
          name: "TimeSeries",
          recipe: "xlsx",
          engine: "handlebars",
          waitForJS: true
        }
      })
        .then(res => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(res, `${vm.title}.xlsx`);
            // for all other web browsers, display the converted PDF as iframe
          } else {
            let url = URL.createObjectURL(res);
            let link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.download = `${vm.title}.xlsx`;

            document.body.appendChild(link);
            link.click();
          }
          vm.isDataLoading = false;
        })
        .catch(() => {});
    }
  },
  computed: {
    loading() {
      return !this.items;
    }
  }
};
</script>

<style scoped></style>
